// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__27NQr","header":"PatientQuestionnaire_header__39QL0","info":"PatientQuestionnaire_info__3qn7I"};